function offset(el) {
    let rect = el.getBoundingClientRect(),
        scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
let menuPosition = offset(document.querySelector('#nav-main'));

if(window.innerWidth > 960){
    window.addEventListener('scroll', function() {
        if(window.scrollY > menuPosition.top + 100){
            document.getElementById('header').classList.add('header--fixed');
        }
        else{
            document.getElementById('header').classList.remove('header--fixed');
        }
    })
}
